import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { ToolsService } from 'src/app/_clusters/services/tools.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-content-update',
  templateUrl: './content-update.component.html',
  styleUrls: ['./content-update.component.scss']
})
export class ContentUpdateComponent implements OnInit {
  int_subject_ids: string[] = [
    "5fdf99246bcbd70b7fdb6b6b600e6d35", 
    "a1a8cddccb57f50303507da5087ed062",
    "c53f9b7df8fbb22dc12d0e859a5c9734",
    "e3cabe6023121c56d1ffa9a8b12e100a",
    "9eeb9a6ec1f23e922bc44fef3efbb772",
    "b082ef78d9ebe9fc85f86747040746a5"
  ]
  contentUpdateDetails: any = [];
  txt_topic: string = '';
  trustedUrl: SafeResourceUrl;

  constructor(
    public modalRef: MDBModalRef,
    public toolsService: ToolsService,
    private sanitizer: DomSanitizer
  ) { }

  accordionItems: any[] = [];
  headers: string[] = [
    "If you are using the 2024 edition Miles Concept Notes, refer Q1 2025 and Q1 2026 updates below",
    "If you are using the 2025 edition Miles Concept Notes, refer Q1 2026 updates below",
    "If you are using the 2026 edition Miles Concept Notes, refer Q1 2027 updates below"
  ];

  ngOnInit(): void { 
    window.scroll({top:0,left:0,behavior:"smooth"});
    this.toolsService.contentUpdate(this.int_subject_ids).subscribe((res: any) => {
      if (res.status && res.data) {
        const dataKeys = Object.keys(res.data);
        this.accordionItems = dataKeys.map((key, index) => {
          console.log(key)
          console.log(res.data[key][0].txt_heading)
          return {
            title: res.data[key][0].txt_heading? res.data[key][0].txt_heading : `Content Updates`,
            subjects: res.data[key],
            is_new_key: key // is_new_1, is_new_2, etc.
          };
        });
        // console.log('Accordion Items:', this.accordionItems);
      }
    })
  }

  getVideoUrl(url: string, txt_topic: string) {
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.txt_topic = txt_topic
  }

  checkYear(topic: string, year: string): boolean {
    if (year === '2025') {
      return !topic.includes('2025');
    }
    return true;
  }

}

